import React from "react";
import classes from './ListofAccount.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation } from 'react-router-dom';
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import { Eye, Edit, Trash } from "lucide-react";
import Footer from "../../Components/Footer/Footer";
const ListofAccount= () => {
    const location = useLocation();

    const accountsData = [
        { code: "1000", name: "Cash at Bank", type: "Assets", category: "Current Assets", balance: "₦6,000,000.00", status: "Active" },
        { code: "1000", name: "Cash at Bank", type: "Assets", category: "Current Assets", balance: "₦6,000,000.00", status: "Active" },
        { code: "1000", name: "Cash at Bank", type: "Assets", category: "Current Assets", balance: "₦6,000,000.00", status: "Active" },
        { code: "1000", name: "Cash at Bank", type: "Assets", category: "Current Assets", balance: "₦6,000,000.00", status: "Active" },
        { code: "1000", name: "Cash at Bank", type: "Assets", category: "Current Assets", balance: "₦6,000,000.00", status: "Active" },
        { code: "1000", name: "Cash at Bank", type: "Assets", category: "Current Assets", balance: "₦6,000,000.00", status: "Active" },
        { code: "2000", name: "Accounts Payable", type: "Liabilities", category: "Current Liabilities", balance: "₦2,600,000.00", status: "Active" },
        { code: "2100", name: "VAT Payable", type: "Liabilities", category: "Current Liabilities", balance: "₦450,000.00", status: "Active" },
        { code: "3000", name: "Share Capital", type: "Equity", category: "Equity", balance: "₦10,000,000.00", status: "Active" },
        { code: "4000", name: "Sales Revenue", type: "Revenue", category: "Operating Revenue", balance: "₦12,000,000.00", status: "Active" },
        { code: "5000", name: "Cost of Goods Sold", type: "Expenses", category: "Cost of Sales", balance: "₦8,500,000.00", status: "Active" },
        { code: "6000", name: "Operating Expenses", type: "Expenses", category: "Operating Expenses", balance: "₦2,800,000.00", status: "Active" },
    ];

    const getTypeClass = (type) => {
        switch (type) {
            case "Assets": return classes.asset;
            case "Liabilities": return classes.liability;
            case "Equity": return classes.equity;
            case "Revenue": return classes.revenue;
            case "Expenses": return classes.expense;
            default: return "";
        }
    };

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                {/* Top Actions */}
                <div className={classes.actions}>
                    <button className={classes.btns}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
                </div>

                {/* Header */}
                <header className={classes.Header}>
                    <h2 className={classes.Title}>Charts of Accounts</h2>
                    <p className={classes.Titles}>
                        Manage your company's account structure and view account balances.
                    </p>
                </header>

                {/* Filter/Action Bar */}
                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                            <input type="text" className={classes.searchBar} placeholder="Search..." />
                        </div>
                        <div className={classes.inputWrapper}>
                            <input type="text" className={classes.searchBars} placeholder="All types" />
                        </div>
                        <div className={classes.inputWrapper}>
                            <input type="text" className={classes.searchBars} placeholder="Filter..." />
                            <img src={filter} alt="Filter" className={classes.inputIcon} />
                        </div>
                    </div>
                    <button className={classes.btnss}> + New Accounts</button>
                </div>

                {/* Table */}
                <div className={classes.tableContaer}>
                    <table className={classes.table}>
                        <thead className={classes.tableHeader}>
                            <tr>
                                <th>Account Code</th>
                                <th>Account Name</th>
                                <th>Type</th>
                                <th>Category</th>
                                <th>Balance</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {accountsData.map((item, index) => (
                                <tr key={index} className={classes.tableRow}>
                                    <td className={classes.tableCell}>{item.code}</td>
                                    <td className={classes.tableCell}>{item.name}</td>
                                    <td className={classes.tableCell}>
                                        <span className={`${classes.typeBadge} ${getTypeClass(item.type)}`}>
                                            {item.type}
                                        </span>
                                    </td>
                                    <td className={classes.tableCell}>{item.category}</td>
                                    <td className={`${classes.tableCell} ${item.code === "2100" ? classes.boldBalance : ""}`}>
                                        {item.balance}
                                    </td>
                                    <td className={classes.tableCell}>
                                        <span className={classes.activeBadge}>Active</span>
                                    </td>
                                    <td className={`${classes.tableCell} ${classes.iconActions}`}>
                                        <Eye size={16} />
                                        <Edit size={16} style={{ margin: '0 8px' }} />
                                        <Trash size={16} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>


                {/* Pagination */}
                {/* Uncomment below when you implement pagination */}
                {/* 
                <table className={classes.footerTable}>
                    <tfoot>
                        <tr>
                            <td>First</td>
                            <td className={`${classes.page} ${classes.activePage}`}>1</td>
                            <td className={classes.page}>2</td>
                            <td>Last</td>
                        </tr>
                    </tfoot>
                </table>
                <div className={classes.paginationDisplay}>Displaying 1 - 25 of 41</div> 
                */}
            </div>
            <Footer />
        </div>
    );
};

export default ListofAccount;
